export default __webpack_public_path__ + "static/media/git.c06d5def.png";